<template>
  <div>
    <!--面包屑导航-->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>销售系统</el-breadcrumb-item>
      <el-breadcrumb-item>销售记录</el-breadcrumb-item>
    </el-breadcrumb>
    <!--卡片视图区域-->
    <el-card>
      <!--筛选区域：每个筛选项前面加上名称-->
      <el-form :inline="true" :model="queryInfo" class="search-form">
        <el-form-item label="厂家：">
          <el-input
            placeholder="厂家名称"
            v-model="queryInfo.query"
            clearable
            style="width: 80px"
            size="mini"
          />
        </el-form-item>
        <el-form-item label="类型：">
          <el-select
            v-model="queryInfo.typeOutgoods"
            placeholder="请选择"
            clearable
            style="width: 65px"
            size="mini"
            @change="handleTypeChange"
          >
            <el-option label="紫铜" value="紫铜"></el-option>
            <el-option label="黄铜" value="黄铜"></el-option>
            <el-option label="铜包铜" value="铜包铜"></el-option>
            <el-option label="成品" value="成品"></el-option>
            <el-option label="其他" value="其他"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="出库时间：">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="~"
            start-placeholder="开始"
            end-placeholder="结束"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            style="width: 155px"
            size="mini"
            @change="handleDateRangeChange"
            clearable
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getUserList" size="mini">搜索</el-button>
          <el-button icon="el-icon-refresh-left" @click="resetSearch" size="mini">重置</el-button>
        </el-form-item>
      </el-form>

      <!--操作与统计栏-->
      <el-row :gutter="20" class="action-bar">
        <el-col :span="8">
          <el-button type="primary" icon="el-icon-plus" @click="openAddDialog" size="small">添加记录</el-button>
        </el-col>
        <el-col :span="16" class="stats-col">
          <el-tag type="success" size="small" effect="plain">
            <i class="el-icon-s-data"></i> 毛重总量：<strong>{{ totalMaoWeight }}</strong> 吨
          </el-tag>
          <el-tag type="warning" size="small" effect="plain" style="margin-left: 6px;">
            <i class="el-icon-s-data"></i> 净重总量：<strong>{{ totalJingWeight }}</strong> 吨
          </el-tag>
          <el-tag type="info" size="small" effect="plain" style="margin-left: 6px;">
            共 <strong>{{ total }}</strong> 条记录
          </el-tag>
        </el-col>
      </el-row>

      <!--用户表格区域-->
      <el-table
          border
          :data="userList"
          stripe
          size="small"
          class="outgoods-table">
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column prop="sendOutgoodsTime" label="出库时间" width="105"></el-table-column>
        <el-table-column prop="typeOutgoods" label="类型" width="70"></el-table-column>
        <el-table-column prop="modelOutgoods" label="规格" width="90"></el-table-column>
        <el-table-column prop="maoWeight" label="毛重（kg）" width="95"></el-table-column>
        <el-table-column prop="sendOutgoodsNum" label="净重（kg）" width="95"></el-table-column>
        <el-table-column prop="priceOutgoods" label="单价（元）" width="95"></el-table-column>
        <el-table-column prop="priceOutgoodsSum" label="总价（元）" width="100"></el-table-column>
        <el-table-column prop="factoryOutgoods" label="厂家" show-overflow-tooltip></el-table-column>
        <el-table-column prop="namePeopleSendOutgoods" label="拉货人" width="90"></el-table-column>
        <el-table-column prop="recordOutgoodsTIme" label="记录时间" width="110" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" width="130" fixed="right" class-name="compact-actions">
          <template v-slot:default="scope">
            <el-button type="primary" icon="el-icon-edit" size="mini" class="action-btn"
                       @click="openEditDialog(scope.row)"></el-button>
            <el-button type="danger" icon="el-icon-delete" size="mini" class="action-btn"
                       @click="deleteUser(scope.row._id)"></el-button>
            <el-button type="success" icon="el-icon-printer" size="mini" class="action-btn"
                       @click="printTableData(scope.row)"></el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--分页区域-->
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.pagenum"
          :page-sizes="[1, 2, 5, 10]"
          :page-size="queryInfo.pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          size="small">
      </el-pagination>
    </el-card>
    <!--新增+编辑，对话框-->
    <el-dialog
      @close="dialogClose"
      :title="isEdit ? '修改记录' : '添加记录'"
      :visible.sync="dialogVisible"
      width="40%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form
        :model="formData"
        :rules="userInfoRules"
        ref="formRef"
        label-width="100px"
      >
        <!-- 表单内容复用（原添加/编辑的表单项整合） -->
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item label="出库时间" prop="sendOutgoodsTime">
              <el-date-picker
                v-model="formData.sendOutgoodsTime"
                type="date"
                placeholder="选择出库日期"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="类型" prop="typeOutgoods">
              <el-select
                v-model="formData.typeOutgoods"
                placeholder="请选择类型"
                style="width: 100%"
              >
                <el-option label="紫铜" value="紫铜"></el-option>
                <el-option label="黄铜" value="黄铜"></el-option>
                <el-option label="铜包铜" value="铜包铜"></el-option>
                <el-option label="成品" value="成品"></el-option>
                <el-option label="其他" value="其他"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 其他表单项（型号、毛重、净重、单价、厂家等）统一用formData绑定 -->
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item label="型号" prop="modelOutgoods">
              <el-input v-model="formData.modelOutgoods"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="根数" prop="numModelOutgoods">
              <el-input v-model="formData.numModelOutgoods"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item label="毛重" prop="maoWeight">
              <el-input v-model="formData.maoWeight"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="皮重" prop="piWeight">
              <el-input v-model="formData.piWeight"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item label="【净重】" prop="sendOutgoodsNum">
              <el-input v-model="formData.sendOutgoodsNum">
                <template slot="suffix">
                  <span style="color: #606266; font-size: 14px; margin-right: 10px;">公斤</span>
                </template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="轴型" prop="zhouModel">
              <el-input v-model="formData.zhouModel"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item label="单价" prop="priceOutgoods">
              <el-input v-model="formData.priceOutgoods">
                <template slot="suffix">
                  <span style="color: #606266; font-size: 14px; margin-right: 10px;">元</span>
                </template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="【总价】" prop="priceOutgoodsSum">
              <el-input v-model="formData.priceOutgoodsSum">
                <template slot="suffix">
                  <span style="color: #606266; font-size: 14px; margin-right: 10px;">元</span>
                </template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item label="厂家" prop="factoryOutgoods">
              <el-input v-model="formData.factoryOutgoods"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="取货人" prop="namePeopleSendOutgoods">
              <el-input v-model="formData.namePeopleSendOutgoods"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="备注" prop="someInfo">
          <el-input v-model="formData.someInfo"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <!-- 仅保存：传 false -->
        <el-button type="primary" @click="submitForm(false)">仅保存</el-button>
        <!-- 保存并打印：传 true -->
        <el-button type="success" @click="submitForm(true)">保存并打印</el-button>
      </span>
    </el-dialog>
    <!-- 打印模板 -->
    <div
      id="print-template"
      style="
        position: absolute;
        left: -9999px;
        top: -9999px;
        width: 76mm;
        /* 仅修改以下3行：提升字体清晰度 */
        font-family: 'Courier New', 'SimHei', monospace !important;
        font-size: 13px !important;
        /* 保留原有样式 */
        white-space: pre-wrap;
        line-height: 1.4;
        word-wrap: break-word !important;
        word-break: break-all !important;
      "
    >
      <pre>{{ printContent }}</pre>
    </div>
  </div>
</template>
<script>
import outgoodsMain from './outgoodsMain.js';
export default {
  name: "outgoods",
  mixins: [outgoodsMain] // 混入所有逻辑
};
</script>
<style scoped>
/* 筛选表单样式 */
.search-form {
  margin-bottom: 0;
  padding: 8px 12px;
  background-color: #f5f7fa;
  border-radius: 4px;
  border: 1px solid #ebeef5;
}
.search-form >>> .el-form-item {
  margin-bottom: 0;
  margin-right: 8px;
}
.search-form >>> .el-form-item__label {
  font-weight: 500;
  color: #606266;
  padding-right: 4px;
  font-size: 13px;
}
.search-form >>> .el-input__inner,
.search-form >>> .el-range-editor.el-input__inner {
  font-size: 13px;
}

/* 操作与统计栏 */
.action-bar {
  margin-top: 10px;
  margin-bottom: 10px;
  align-items: center;
  padding: 8px 12px;
  background-color: #fafafa;
  border-radius: 4px;
  border: 1px solid #ebeef5;
}
.stats-col {
  text-align: right;
}

/* 表格样式 */
.outgoods-table {
  margin-bottom: 10px;
}
.outgoods-table >>> .el-table__header th {
  background-color: #f5f7fa;
  color: #303133;
  font-weight: 600;
  font-size: 13px;
  padding: 6px 0;
}
.outgoods-table >>> .el-table__body td {
  font-size: 13px;
  padding: 5px 0;
}

/* 分页样式 */
.el-pagination {
  margin-top: 10px;
  text-align: right;
}

/* 操作列按钮紧凑样式 */
.outgoods-table >>> .compact-actions .cell {
  padding: 0 2px;
  white-space: nowrap;
}
.outgoods-table >>> .compact-actions .action-btn {
  padding: 5px 6px;
  margin-left: 2px;
  min-width: 28px;
}
.outgoods-table >>> .compact-actions .action-btn:first-child {
  margin-left: 0;
}

/* 移除强制350px宽度，改为自适应 */
  .el-form-item >>> .el-input,
  .el-form-item >>> .el-select,
  .el-form-item >>> .el-date-editor {
    width: 100% !important; /* 自适应父容器宽度 */
    box-sizing: border-box; /* 防止padding超出宽度 */
  }
  /* 优化对话框内边距，避免内容贴边 */
  .el-dialog__body {
    padding: 20px !important;
  }
  /* 优化表单项间距 */
  .el-form-item {
    margin-bottom: 15px !important;
  }
</style>
<style lang="less" scoped></style>
